import { render, staticRenderFns } from "./ListDokumentasi.vue?vue&type=template&id=aa42ea92&scoped=true"
import script from "./ListDokumentasi.vue?vue&type=script&lang=js"
export * from "./ListDokumentasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa42ea92",
  null
  
)

export default component.exports